// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3fc82d6","453":"5cb852f5","455":"e771bf9e"}[chunkId] + ".chunk.js";
};